<template>
	<div class="px-3 px-lg-5 py-3 pale-bg" >
		<div class="d-none d-md-flex justify-content-center">
				<div class="social">
					<a href="https://twitter.com/daveaji" class="black-text ml-5 mr-4">TWITTER</a> <span>/</span>
					<a href="https://github.com/Ajiva-D" class="black-text mx-4">GITHUB</a> <span>/</span>
					<a href="https://instagram.com/ajiva_d" class="black-text ml-4">INSTAGRAM</a>
				</div>
		</div>
		<div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
			<p class="black-text medium-font mb-4 mb-md-0">©{{year}} David Aji - All Rights Reserved</p>
			<ul class="d-block d-md-none text-center pl-0">
				<li class="mb-3">
					<a href="https://twitter.com/daveaji" class="black-text">TWITTER</a>
				</li>
					<li class="mb-3">
					<a href="https://github.com/Ajiva-D" class="black-text">GITHUB</a>
				</li>
					<li class="mb-3">
					<a href="https://instagram.com/ajiva_d" class="black-text">INSTAGRAM</a>
				</li>
			</ul>
			<div class="py-2 px-5 developed-by mb-4 mb-md-0"><p class="red-text medium-font mb-0">Developed by David Aji</p></div>
			<div class="align-self-start align-self-center mb-4 mb-md-0"><a href="https://dribbble.com/artofofiare" class="black-text medium-font mb-0"><img src="../assets/svgs/Icon-ionic-md-key.svg" alt=""> Design by David Ofiare</a></div>
		</div>
	</div>
</template>

<script>
export default {
	computed:{
		year(){
			return new Date().getFullYear();
		}
	}
}
</script>

<style scoped>
	.developed-by{
		border:1px solid #71201c;
	}
</style>